import React from 'react'
import Navbar from './Navbar'
import Skills from './Skills'
import Projects from './Projects'
import Services from './Services'
import Qualifications from './Qualifications'
import Contact from './Contact'
import Footer from './Footer'

import '../css/BottomSection.css'

const BottomSection = () => {
    return (
        <div className="bottom-section">
            <Navbar />
            <Skills />
            <Projects />
            <Services />
            <Qualifications />
            <Contact />
            <Footer />
        </div>
    )
}

export default BottomSection
